import React from 'react';
import InputDateTime from "../../input/input-datetime.jsx";
import SelectComponent from "../../select/select-component.jsx";
import ReportUtils from "../../../utils/report-utils.js";

const TimePeriodInput = ({ filters, setFilters, singleRow = false, hasSeconds = null }) => {

    return (
        <>
            { singleRow ? (
                <>
                    <div className="flex gap-2">
                        <InputDateTime
                            id="hrStart"
                            label="Hora inicial *"
                            selected={filters.hrStart}
                            onChange={(date) => setFilters(prev => ({ ...prev, hrStart: date }))}
                            classNameWrapper={"w-[50%]"}
                            dateFormat={`${hasSeconds ? "LTS" : "LT"}`}
                            hasIcon={false}
                        />

                        <InputDateTime
                            id="hrEnd"
                            label="Hora final *"
                            selected={filters.hrEnd}
                            onChange={(date) => setFilters(prev => ({ ...prev, hrEnd: date }))}
                            classNameWrapper={"w-[50%]"}
                            dateFormat={`${hasSeconds ? "LTS" : "LT"}`}
                            hasIcon={false}
                        />
                    </div>
                </>
            ) : (
                <>
                    <InputDateTime
                        id="hrStart"
                        label="Hora inicial *"
                        selected={filters.hrStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, hrStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LTS"
                    />

                    <InputDateTime
                        id="hrEnd"
                        label="Hora final *"
                        selected={filters.hrEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, hrEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="LTS"
                    />
                </>
            )}

            <SelectComponent
                label='Período *'
                isMulti={false}
                options={ReportUtils.periods()}
                value={filters.period}
                onChange={(value) => ReportUtils.periodChange(value, setFilters)}
                instanceId="period"
                classNameWrapper={"w-full"}
                isClearable={false}
            />
        </>
    );
};

export default TimePeriodInput;